import { useCallback, useState } from "react";
import Popup from "../../../components/Popup";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Spa from "../../../assets/img/SolutionsIcons/AgilysysSpa.svg";
import { Header } from "../../../components/Header";

const SpaFPage = () => {
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page splash spaFPage">
            <div className="page-title"><img src={Spa} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                A modern cloud-native spa management solution for
independent spa operators as well as hotel and resort-
based locations. Cloud-native, mobile software delivers an
effortless check-in and staff scheduling process, while
intuitive drag and drop appointment management helps
maximize therapist and treatment room utilization. And if the 
spa is part of a resort, it can integrate with PMS and POS
solutions, making it easy to share data across the enterprise.{'\n\n'}
                </div>
                <div className="std-text">
                Our guestsense.ai-enabled solution helps optimize
revenue and provides a conversational AI Concierge to
fully automate the entire reservation flow in a natural
conversation.{'\n\n'}
                </div>
                <div className="std-text">
                The result is increased revenue through yield management
insights and an exclusive spa experience for each and every
guest.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - Spa", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Spa1.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveSpa.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default SpaFPage;